import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Card, Divider, Stack, Typography } from '@mui/material';
import { WidgetOrigin } from '../../../types/Statistics.types';

interface WidgetOriginsTableMobileProps {
  rows: WidgetOrigin[];
  showAccount: boolean;
  accountName: (id?: string) => string;
}

export const WidgetOriginsTableMobile: React.FC<
  WidgetOriginsTableMobileProps
> = ({ rows, showAccount, accountName }) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={12} component="ul" sx={{ p: 0, m: 0, mt: 24 }}>
      {rows.map((row) => {
        return (
          <Card
            key={`${row.account ?? ''}-${row.host}${row.path}`}
            component="li"
            variant="primary"
            sx={{ listStyle: 'none', '&:hover': { cursor: 'default' } }}
          >
            <Stack spacing={2}>
              <Box>
                <Typography variant="caption">
                  {t('statistics.table.noOfSearches')}
                </Typography>
                <Typography variant="body1" fontWeight={600}>
                  {row.count.toLocaleString()}
                </Typography>
              </Box>
              {showAccount && (
                <>
                  <Divider />
                  <Box>
                    <Typography variant="caption">
                      {t('statistics.table.account')}
                    </Typography>
                    <Typography variant="body1">
                      {accountName(row.account) || '-'}
                    </Typography>
                  </Box>
                </>
              )}
              <Divider />
              <Box>
                <Typography variant="caption">
                  {t('statistics.table.host')}
                </Typography>
                <Typography variant="body1" sx={{ overflowWrap: 'anywhere' }}>
                  {row.host}
                </Typography>
              </Box>
              <Divider />
              <Box>
                <Typography variant="caption">
                  {t('statistics.table.page')}
                </Typography>
                <Typography variant="body1" sx={{ overflowWrap: 'anywhere' }}>
                  {row.path}
                </Typography>
              </Box>
            </Stack>
          </Card>
        );
      })}
    </Stack>
  );
};
